/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CustomerProgress = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;
export type CustomerProgress = typeof CustomerProgress[keyof typeof CustomerProgress];


export function CustomerProgressFromJSON(json: any): CustomerProgress {
    return CustomerProgressFromJSONTyped(json, false);
}

export function CustomerProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerProgress {
    return json as CustomerProgress;
}

export function CustomerProgressToJSON(value?: CustomerProgress | null): any {
    return value as any;
}

